import { Box, Flex } from '@mantine/core';
import { ImageStripSlide } from '@/app/components/shared/viewer/ImageStripSlide';
import { MouseEventHandler, useCallback, useState } from 'react';
import Image from 'next/image';

interface TurnTableProps {
  images: { title: string; src: string; posX?: number }[];
  height: number;
}

export default function TurnTable({ images, height }: TurnTableProps) {
  const [index, setIndex] = useState(0);

  const handleMouseOver: MouseEventHandler = useCallback(
    (event) => {
      const { clientX, currentTarget } = event;
      const { left, width } = currentTarget.getBoundingClientRect();
      const relativeX = clientX - left;
      const image = Math.round((relativeX / width) * images.length) % images.length;
      setIndex(image);
    },
    [images.length]
  );

  if (!images.length) {
    return <Box>No images found!</Box>;
  }

  return (
    <Flex onMouseMove={handleMouseOver} onMouseLeave={() => setIndex(0)} justify='center'>
      {images[index].posX ? (
        <ImageStripSlide src={images[index].src} positionX={images[index].posX ?? 0} height={height} />
      ) : (
        <Image width={400} height={400} alt='Preview image' src={images[index].src} />
      )}
    </Flex>
  );
}
